import {GameFlowController} from '../../components/game-flow-controller.js';

export function goToCredits() {
    const gameFlow = GameFlowController.instance;

    gameFlow.goToCredits();
}

export function leaveCredits() {
    const gameFlow = GameFlowController.instance;

    gameFlow.leaveCredits();
}
